export default {
  SET_CARD_DELETED: 'PAYMENT / SET CARD DELETED',
  SET_FORTER_TOKEN: 'PAYMENT / SET FORTER TOKEN',
} as const;
